export default __webpack_public_path__ + "static/media/people.a4955ce0.png";